package pwgs.ui.scenes.customentityeditorscene

import pwgs.ui.scenes.custompropertieseditorscene.ECustomFieldType
import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption
import visage.ds.utils.EHAlign

class MCustomEntityEditorScene(props: CustomEntityEditorSceneProps) : AScene<CustomEntityEditorSceneProps, CustomEntityEditorSceneModel, CustomEntityEditorSceneState, CustomEntityEditorControllerFe>(props) {

    override fun createController() : CustomEntityEditorControllerFe {
        return CustomEntityEditorControllerFe(props, this)
    }

    override fun initState() : CustomEntityEditorSceneState {
        return CustomEntityEditorSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MCustomEntityEditorScene.model
        val c = this@MCustomEntityEditorScene.controller
        Card {
            isLoading = m.isLoading
            header("Fields")

            body {
                Table {
                    columns {
                        fixedColumn("Field")
                        fixedColumn("Type")
                        fixedColumn("Value")
                        fixedColumn("", hAlign = EHAlign.Right)
                    }
                    body {
                        m.fields.forEach { field ->
                            if (field.isHidden) {
                                return@forEach
                            }
                            row {
                                cell(field.fieldName)
                                cell(field.fieldType.name)
                                cell(field.fieldValue)
                                cell {
                                    if (field.isEditable) {
                                        IconButton("edit") {
                                            size = EButtonSize.Small
                                            color = EButtonColor.Warning
                                            variant = EButtonVariant.Link
                                            onClick = {c.onEditFieldButtonClicked(field)}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (m.editorDialogModel != null) {
            val dlg = m.editorDialogModel!!
            Modal("Edit ${dlg.fieldName} value") {
                TextField("Field name", FieldModel(dlg.fieldName)) {
                    disabled = true
                }
                TextField("Type", FieldModel(dlg.fieldType.name)) {
                    disabled = true
                }
                if (dlg.fieldType == ECustomFieldType.Bool) {
                    Select("Value", dlg.boolFieldModel)
                } else {
                    TextField("Value", dlg.otherFieldModel)
                }

                footer {
                    Button("Cancel", EButtonColor.Secondary, EButtonVariant.Link, c::onCancelEditFieldButtonClicked)
                    Button("Submit", EButtonColor.Primary, EButtonVariant.Filled, c::onSubmitNewFieldValueButtonClicked)
                }
            }
        }
    }
}

class CustomEntityEditorSceneState {

}

fun Components.CustomEntityEditorScene(props: CustomEntityEditorSceneProps) = this.registerComponent(MCustomEntityEditorScene(props), {})
